import { render, staticRenderFns } from "./CashGiftModal.vue?vue&type=template&id=dd4bf860"
import script from "./CashGiftModal.vue?vue&type=script&lang=js"
export * from "./CashGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports